export default __webpack_public_path__ + "static/media/drag_drop.a54709d2.svg";